<template>
  <div class="dft-container" :style="container_Style">
    <div class="dft-list unic" v-if="showTopGoods&&unicOne" :style="top_list_Style">
      <div class="dft-item" :style="top_list_item_Style">
        <div class="dft-goods_img" :style="top_goods_img_Style">
          <el-image class="img_class" :style="image_Style" :src="unicOne.listImg" :fit="fit"></el-image>
        </div>
        <div class="dft-goods_description" :style="top_goods_description_Style">
          <div class="dft-goods_name" v-if="goodsName" :style="top_goods_name_Style">{{ unicOne.productName }}</div>
          <div class="dft-goods_info" v-if="show_goods_info" :style="goods_info_Style">{{ unicOne.introduce }}</div>
          <el-progress class="dft-goods_info dft-progress" v-if="showProgress&&!isNaN(Number(unicOne.surplusStock/unicOne.stock*100))" style="flex: none;"
            :percentage="Number(unicOne.surplusStock/unicOne.stock*100)" :stroke-width="13" color="#f44" :show-text="false"></el-progress>
          <div class="dft-goods_info" v-if="goodsSaleNum || showProgress" style="flex: none;">
            <div class="dft-goods_info1">
              <!-- <span v-if="goodsSaleNum">{{ unicOne.surplusStock>0?`仅剩${unicOne.surplusStock}件`:'已售罄' }}</span> -->
            </div>
            <div class="dft-goods_info2">
              <!-- <span v-if="showProgress">已抢{{ unicOne.saleVolume }}件</span> -->
            </div>
          </div>

          <div class="dft-press_area" style="padding-top: '12px';">
            <div class="dft-goods_price" v-if="goodsPrice" :style="top_goods_price_Style">
              <div class="price-tag">团购价 ¥</div>
              <div class="price-sale-price" style="font-weight: 600;">{{ unicOne.sellPrice }}</div>
              <div class="price-origin-price unic_price-origin-price" v-if="goodsOldPrice">¥{{ unicOne.originalPrice }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="dft-groupinfo">
        <div class="dft-groupinfo_top">
          <div class="dft-groupinfo_top_s">{{ unicOne.groupPurchaseCount || 0 }}</div>
          人已拼
          <div class="dft-groupinfo_top_s">{{ unicOne.saleVolume || 0 }}</div>
          件 &nbsp;
          <div class="dft-groupinfo_top_s">
            <countdown :endTime="new Date(unicOne.endTime).getTime()/1000" :callback="handleFinish()"
                hourTxt=":" minutesTxt=":" secondsTxt=""></countdown>
          </div> 后结束
        </div>
        <div class="dft-groupinfo_avatar">
          <div class="dft-groupinfo_avatar_item" v-for="(item,index) in getGroupInfo(unicOne.activityCode)" :key="index">
            <el-avatar size="small" :src="item.memberLogo || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'"></el-avatar>
          </div>
          <div class="omit"></div>
        </div>
      </div>
      <div class="dft-groupBtn">
        参与拼团
      </div>
    </div>

    <div class="tabin" v-if="curtab.categoryList.length>0" :style="tabs_Style">
      <div class="ctag_item" :class="tagIndex == -1?'activeTag':''" @click="getCgoods(curtab,{},-1)">
        全部
      </div>
      <div class="ctag_item" :class="tagIndex == tagindex?'activeTag':''" v-for="(tag,tagindex) in curtab.categoryList" :key="tag.groupId" @click="getCgoods(curtab,tag,tagindex)">
        {{ tag.categoryName }}
      </div>
    </div>
    <div class="dft-list" :style="list_Style">
      <div :ref="'dftItem'+index" class="dft-item" v-for="(item,index) in (grouponWeappListData.length>0?grouponWeappListData:dftList)" :key="index" :style="list_item_Style(index)">
        <div class="dft-goods_img" :style="goods_img_Style">
          <el-image class="img_class" :style="image_Style" :src="item.listImg" :fit="fit"></el-image>
          <div class="countdown_area" v-if="showCountDown && hascountdown">
            <div class="countdown_title" v-if="countInfo(index)">拼团</div>
            <div class="countdown_cnt" :style="countdown_cnt_style(index)">
              <div class="countdown_info">{{ countInfo(index)?'距结束仅剩':'距结束' }}</div>
              <div class="countdown_time">
                <countdown v-if="countInfo(index)" :endTime="new Date(item.endTime).getTime()/1000" :callback="handleFinish(item)"></countdown>
                <countdown v-else :endTime="new Date(item.endTime).getTime()/1000" :callback="handleFinish(item)"
                  hourTxt=":" minutesTxt=":" secondsTxt=""></countdown>
              </div>
            </div>
          </div>
          <div v-if="showGrouponNum" class="grouponNum" :style="grouponNum_style(index)">{{item.groupPurchaseCount||0}}人已团</div>
        </div>
        <div class="dft-goods_description" :style="goods_description_Style">
          <div class="dft-goods_name" v-if="goodsName" :style="goods_name_Style(index)">{{ item.productName }}</div>
          <div class="dft-goods_info" v-if="show_goods_info" :style="goods_info_Style">{{ item.introduce }}</div>
          <el-progress class="dft-goods_info dft-progress" v-if="showProgress&&!isNaN(Number(item.surplusStock/item.stock*100))" style="flex: none;"
            :percentage="Number(item.surplusStock/item.stock*100)" color="#f44" :show-text="false"></el-progress>
          <div class="dft-goods_info" v-if="goodsSaleNum || showProgress" style="flex: none;">
            <div class="dft-goods_info1">
              <!-- <span v-if="goodsSaleNum">{{ item.surplusStock>0?`仅剩${item.surplusStock}件`:'已售罄' }}</span> -->
            </div>
            <div class="dft-goods_info2">
              <span v-if="showProgress">已抢{{ item.saleVolume }}件</span>
            </div>
          </div>

          <div class="dft-press_area" :style="press_area_style">
            <div class="dft-goods_price" v-if="goodsPrice" :style="goods_price_Style(index)">
              <div class="price-tag">¥</div>
              <div class="price-sale-price">{{ item.sellPrice }}</div>
              <div class="price-origin-price" v-if="goodsOldPrice">¥{{ item.originalPrice }}</div>
            </div>
            <div class="dft-goods_btn" v-if="showBtn" :style="goods_btn_Style(index)">
              <div v-if="btn_class == '1'" class="dft-goods_btn-class dft-goods_btn-class1" :style="goods_btn_Style_scale(index)">
                <i class="el-icon-shopping-cart-2 btn-icon"></i>
              </div>
              <div v-else-if="btn_class == '2'" class="dft-goods_btn-class" :style="goods_btn_Style_scale(index)">
                <i class="el-icon-circle-plus-outline btn-icon"></i>
              </div>
              <div v-else-if="btn_class == '3'" class="dft-goods_btn-class dft-goods_btn-class3">
                <span class="">{{ btn_class_options[btn_class] }}</span>
              </div>
              <div v-else-if="btn_class == '4'" class="dft-goods_btn-class dft-goods_btn-class4">
                <span class="">{{ btn_class_options[btn_class] }}</span>
              </div>
              <div v-else-if="btn_class == '5'" class="dft-goods_btn-class" :style="goods_btn_Style_scale(index)">
                <i class="el-icon-circle-plus btn-icon"></i>
              </div>
              <div v-else-if="btn_class == '6'" class="dft-goods_btn-class" :style="goods_btn_Style_scale(index)">
                <i class="el-icon-shopping-cart-2 btn-icon"></i>
              </div>
              <div v-else-if="btn_class == '7'" class="dft-goods_btn-class dft-goods_btn-class7">
                <span class="">{{ btn_class_options[btn_class] }}</span>
              </div>
              <div v-else-if="btn_class == '8'" class="dft-goods_btn-class dft-goods_btn-class8">
                <span class="">{{ btn_class_options[btn_class] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countdown from '@/components/countdown.vue'
export default {
  components: {
    countdown
  },
  props: {
    compData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showDialog: false,
      dftList: [],
      cd999: '9',
      curtab: {
        categoryList: []
      },
      curtabIndex: 0,
      tagIndex: -1,
      queryInfo: {
        condition: {
        },
        currPage: 1,
        pageSize: 100
      },
      grouponWeappListData: []
      // unicOneGInfo: [],
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            // console.log('thdfghjk---1',newVal[0]?.groupList[0])
            this.curtab = newVal[0]?.groupList?.[0]
            this.goodsList(this.curtab)
            switch (newVal[1]?.value) {
              case 0:
              case 2:
              case 3:
                this.dftList = [{
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/8cf0c263c498b0a6c8e7901681eddd57.jpeg!large.webp',
                  productName: '商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称',
                  introduce: '商品描述---6',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测试2',
                  introduce: '商品描述---444发',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/afecab1e62f85478c3e672a048f677a2.jpeg!large.webp',
                  productName: '商品名称---测试9',
                  introduce: '商品描述---effect',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }]
                break
              case 1:
              case 4:
                this.dftList = [{
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/8cf0c263c498b0a6c8e7901681eddd57.jpeg!large.webp',
                  productName: '商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称',
                  introduce: '商品描述---6',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测试2',
                  introduce: '商品描述---444发',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/afecab1e62f85478c3e672a048f677a2.jpeg!large.webp',
                  productName: '商品名称---测试9',
                  introduce: '商品描述---effect',
                  sellPrice: '220',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测789999999999',
                  introduce: '商品描述---撒旦发射点佛为',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }]
                break
              case 5:
                this.dftList = [{
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/8cf0c263c498b0a6c8e7901681eddd57.jpeg!large.webp',
                  productName: '商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称',
                  introduce: '商品描述---6',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测试2',
                  introduce: '商品描述---444发',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/afecab1e62f85478c3e672a048f677a2.jpeg!large.webp',
                  productName: '商品名称---测试9',
                  introduce: '商品描述---effect',
                  sellPrice: '220',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测789999999999',
                  introduce: '商品描述---撒旦发射点佛为',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/8cf0c263c498b0a6c8e7901681eddd57.jpeg!large.webp',
                  productName: '商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称---测试商品名称',
                  introduce: '商品描述---6',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/e90c4ea59d942625b60d22f936fbaf6d.jpg!large.webp',
                  productName: '商品名称---测试2',
                  introduce: '商品描述---444发',
                  sellPrice: '20',
                  endTime: '2024-12-21 12:12:12'
                }, {
                  listImg: 'https://img01.yzcdn.cn/upload_files/2024/11/29/afecab1e62f85478c3e672a048f677a2.jpeg!large.webp',
                  productName: '商品名称---测试9',
                  introduce: '商品描述---effect',
                  sellPrice: '220',
                  endTime: '2024-12-21 12:12:12'
                }]
                break

              default:
                break
            }
            // console.log('comp--D-ata==--??',newVal,this.dftList)
          })
        }
      },
      deep: true
    }
  },
  computed: {
    // 数据
    groupList () {
      return this.compData[0]?.groupList.length > 0 ? this.compData[0]?.groupList : []
    },
    // 商品数据
    // grouponWeappList() {
    //   return this.compData[0]?.groupList[0].grouponWeappList || []
    // },
    unicOne () {
      return this.grouponWeappListData[0]
    },
    // unicOneGInfo(){
    //   return async activityCode=>{
    //     const _info = await this.getGroupInfo(activityCode)
    //     console.log('goghielnd---0',activityCode, _info)
    //     return _info
    //   }
    // },
    // 数据
    goodsList () {
      return async (curtab) => {
        // const _index = this.groupList.findIndex(item=>item.groupId == this.curtab.groupId)
        const _SeckillListData = await this.getgoods(this.curtab)
        // this.curtabIndex = _index
        this.grouponWeappListData = _SeckillListData
        // console.log('this.compData[0]?.groupList[0]---4',_SeckillListData,curtab)
        return _SeckillListData
      }
    },
    listClass () {
      return this.compData[1]?.value
    },
    goodsClass () {
      return this.compData[2]?.value
    },
    // 显示与否
    goodsName () {
      return this.compData[10]?.value == '1'
    },
    // 是否显示商品描述
    show_goods_info () {
      return this.compData[11]?.value == '1'
    },
    // 是否显示商品价格
    goodsPrice () {
      return this.compData[12]?.value == '1'
    },
    // 是否显示商品原价
    goodsOldPrice () {
      return this.compData[13]?.value == '1'
    },
    // 是否显示 销量/数量
    goodsSaleNum () {
      return this.compData[14]?.value == '1'
    },
    // 是否显示 按钮
    showBtn () {
      return this.compData[15]?.value == '1'
    },
    //  按钮 样式
    btn_class () {
      return this.compData[16]?.value
    },
    //  按钮 样式 值
    btn_class_options () {
      return this.compData[16]?.options
    },
    // 是否显示 倒计时
    showCountDown () {
      return this.compData[17]?.value == '1'
    },
    // 是否显示 进度条
    showProgress () {
      return this.compData[18]?.value == '1'
    },
    // 是否显示 拼团人数
    showGrouponNum () {
      return this.compData[20]?.value == '1'
    },
    // 是否显示 首位推荐
    showTopGoods () {
      return this.compData[21]?.value == '1'
    },
    // 样式
    container_Style () {
      return {
        [this.compData[2]?.key]: this.compData[2]?.value,
        [this.compData[7]?.key]: this.compData[7]?.value,
        [this.compData[8]?.key]: this.compData[8]?.value == '1' ? '1px solid #e7e7e7' : 'none',
        'background-color': this.goodsClass == '1' || this.goodsClass == '3' ? '#ffffff' : 'transparent'
      }
    },

    // main首推样式-----------
    top_list_Style () {
      return {
        'flex-direction': 'column',
        'margin-top': '8px',
        'margin-bottom': '2px',
        'padding': `0`,
        'margin-left': `${this.compData[8]?.value / 2}px`,
        'margin-right': `${this.compData[8]?.value / 2}px`,
        'padding-top': this.goodsClass == '1' ? '0' : '0',
        'padding-bottom': this.goodsClass == '1' ? '6px' : '0',
        'background-color': '#ffffff'// this.goodsClass=='4'?'transparent':'#ffffff',
      }
    },
    top_list_item_Style () {
      return {
        'display': 'flex',
        'background-color': '#ffffff',
        'margin': `${this.compData[9]?.value / 2}px`,
        'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
        'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
      }
    },
    top_goods_img_Style () {
      return {
        'width': '138px',
        'height': '138px',
        'margin': this.goodsClass == '2' ? '8px 0 8px 8px' : '0',
        'margin-right': '8px',
        'flex-shrink': '0',
        [this.compData[3]?.key]: this.compData[3]?.value
      }
    },
    top_goods_description_Style () {
      return {
        'flex': '1',
        'padding': this.goodsClass == '2' || this.goodsClass == '3' ? '8px 8px 8px 0' : '0'
      }
    },
    top_goods_name_Style () {
      return {
        'max-height': '40px',
        '-webkit-line-clamp': '2',
        [this.compData[6]?.key]: this.compData[6]?.value,
        [this.compData[7]?.key]: this.compData[7]?.value
      }
    },
    top_goods_price_Style () {
      return {
        'font-size': '18px',
        'line-height': '18px',
        [this.compData[6]?.key]: this.compData[6]?.value,
        [this.compData[7]?.key]: this.compData[7]?.value,
        'overflow': 'visible'
      }
    },
    // main首推样式-----------

    tabs_Style () { // 分组
      switch (this.listClass) {
        default:
          return {
            'width': `calc(100% - ${this.compData[8]?.value}px)`,
            'margin': `0 ${this.compData[8]?.value / 2}px`,
            'background-color': '#ffffff' // this.goodsClass=='1'||this.goodsClass=='3'?'#ffffff':'transparent',
            // 'margin-left': `-${this.compData[9]?.value / 2}px`,
            // 'margin-right': `-${this.compData[9]?.value / 2}px`,
          }
      }
    },
    group_tab_style () { // tab
      switch (this.listClass) {
        default:
          return {
            // 'width': `calc((100% - ${this.compData[8]?.value}px) / 2)`,
          }
      }
    },
    list_Style () { // 列表
      switch (this.listClass) {
        case 0:
          return {
            'flex-direction': 'column',
            'padding': `0`,
            'margin-left': `${this.compData[8]?.value / 2}px`,
            'margin-right': `${this.compData[8]?.value / 2}px`,
            'padding-top': this.goodsClass == '1' ? '0' : '0',
            'padding-bottom': this.goodsClass == '1' ? '10px' : '0',
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff'
          }
        case 1:
          return this.goodsClass == 5 ? {
            'display': 'grid',
            'grid-auto-rows': '5px',
            'grid-template-columns': 'repeat(auto-fill, calc(50% - 0))',
            'align-items': 'start',
            'justify-content': 'space-between',
            'padding': `0`,
            'margin-left': `${this.compData[8]?.value / 2}px`,
            'margin-right': `${this.compData[8]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff'
          } : {
            'display': 'grid',
            'grid-template-columns': 'repeat(2, 1fr)',
            'padding': `0`,
            'margin-left': `${this.compData[8]?.value / 2}px`,
            'margin-right': `${this.compData[8]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff'
          }
        case 2:
          return {
            'flex-wrap': 'wrap',
            'padding': `0`,
            'margin-left': `${this.compData[8]?.value / 2}px`,
            'margin-right': `${this.compData[8]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff'
          }
        case 3:
          return {
            'flex-direction': 'column',
            'padding': `0`,
            'margin-left': `${this.compData[8]?.value / 2}px`,
            'margin-right': `${this.compData[8]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff'
          }
        case 4:
          return {
            'flex-wrap': 'nowrap',
            'overflow-x': 'auto',
            'padding': `0`,
            'margin-left': `${this.compData[8]?.value / 2}px`,
            'margin-right': `${this.compData[8]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff'
          }
        case 5:
          return {
            'display': 'grid',
            'grid-template-columns': 'repeat(2, 1fr)',
            'padding': `0`,
            'margin-left': `${this.compData[8]?.value / 2}px`,
            'margin-right': `${this.compData[8]?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff'
          }
        default:
          return {
          }
      }
    },
    list_item_Style () { // 每一项
      return index => {
        switch (this.listClass) {
          case 0:
            return {
              // 'width': '100%',
              'display': 'flex',
              'background-color': '#ffffff',
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 1:
            return this.goodsClass == 5 ? this.getLitemStyle(index) : {
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 2:
            return {
              'width': `calc((100% / 3) - ${this.compData[9]?.value}px)`,
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 3:
            return {
              'width': `calc(100% - ${this.compData[9]?.value}px)`,
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 4:
            return {
              'width': `calc(34% - ${this.compData[9]?.value}px)`,
              'flex-shrink': '0',
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 5:
            return index % 3 == 0 ? {
              'grid-column': '1 / 3',
              'margin': `${this.compData[9]?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            } : {}
          default:
            return {
            }
        }
      }
    },
    // --商品图
    goods_img_Style () {
      switch (this.listClass) {
        case 0:
          return {
            'width': '138px',
            'height': '138px',
            'margin': this.goodsClass == '2' ? '8px 0 8px 8px' : '0',
            'margin-right': '8px',
            'flex-shrink': '0',
            [this.compData[3]?.key]: this.compData[3]?.value
          }
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          return {
            'width': '100%',
            [this.compData[3]?.key]: this.compData[3]?.value,
            [this.compData[4]?.key]: this.compData[4]?.value
          }
        default:
          return {
          }
      }
    },
    image_Style () {
      return {
      }
    },
    fit () {
      return this.compData[5]?.value
    },
    hascountdown () {
      return [0, 1, 3, 5].includes(this.listClass)
    },
    countInfo () {
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
            return false
          case 3:
            return true
          case 5:
            return index % 3 == 0
          default:
            return false
        }
      }
    },
    countdown_cnt_style () { // 倒计时信息
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
            return {
              'width': '100%',
              'justify-content': 'space-between'
            }
          case 3:
            return {
              'flex-direction': 'column'
            }
          case 5:
            return index % 3 == 0 ? {
              'flex-direction': 'column'
            } : {
              'width': '100%',
              'justify-content': 'space-between'
            }
          default:
            return {
            }
        }
      }
    },

    grouponNum_style () { // 已团信息
      return index => {
        switch (this.listClass) {
          case 2:
          case 4:
            return {
              'bottom': '0'
            }
          case 3:
            return {
              'bottom': '40px'
            }
          case 5:
            return index % 3 == 0 ? {
              'bottom': '40px'
            } : {}
          default:
            return {
            }
        }
      }
    },

    goods_description_Style () { // 商品信息
      switch (this.listClass) {
        case 0:
          return {
            'flex': '1',
            'padding': this.goodsClass == '2' || this.goodsClass == '3' ? '8px 4px 0' : '0'
          }
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          return {
            'padding': '0 4px 10px'
          }
        default:
          return {
          }
      }
    },
    goods_name_Style () { // 商品名
      return index => {
        switch (this.listClass) {
          case 0:
            return {
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value
            }
          case 1:
          case 2:
          case 4:
            return {
              'font-size': '12px',
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value
            }
          case 3:
            return {
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value
            }
          case 5:
            return index % 3 == 0 ? {
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value
            } : {
              'font-size': '12px',
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value
            }
          default:
            return {
            }
        }
      }
    },
    goods_info_Style () { // 商品描述
      return {
        'max-height': '32px'
      }
    },
    press_area_style () { // 商品价格区域
      switch (this.listClass) {
        case 0:
        case 3:
          return {
            'padding-top': '12px'
          }
        case 1:
        case 2:
        case 4:
          return {
            'padding-top': '0'
          }
        default:
          return {
          }
      }
    },
    goods_price_Style () { // 商品价格
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
          case 3:
            return {
              'font-size': '18px',
              'line-height': '18px',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value
            }
          case 2:
          case 4:
            return {
              'font-size': '16px',
              'line-height': '16px',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value
            }
          case 5:
            return index % 3 == 0 ? {
              'font-size': '18px',
              'line-height': '18px',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value
            } : {
              'font-size': '16px',
              'line-height': '16px',
              [this.compData[6]?.key]: this.compData[6]?.value,
              [this.compData[7]?.key]: this.compData[7]?.value
            }
          default:
            return {
            }
        }
      }
    },
    goods_btn_Style () { // 商品按钮
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
          case 3:
            return {
              'font-size': '24px',
              'line-height': '20px'
            }
          case 2:
          case 4:
            return {
              'font-size': '18px',
              'line-height': '18px'
            }
          case 5:
            return index % 3 == 0 ? {
              'font-size': '24px',
              'line-height': '20px'
            } : {
              'font-size': '18px',
              'line-height': '18px'
            }
          default:
            return {
            }
        }
      }
    },
    goods_btn_Style_scale () { // 商品按钮
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
          case 3:
            return {
            }
          case 2:
          case 4:
            return {
              'transform': 'scale(0.7)',
              'transform-origin': 'bottom'
            }
          case 5:
            return index % 3 == 0 ? {
            } : {
              'transform': 'scale(0.7)',
              'transform-origin': 'bottom'
            }
          default:
            return {
            }
        }
      }
    }
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
      // console.log('-----2',this.unicOneGInfo(this.unicOne?.activityCode,666))
    })
  },

  methods: {
    initData () {
    },
    hilarity () {},
    handleFinish (item) {},
    // 切换分组
    changeTab (tab, index) {
      this.curtab = tab
      this.curtabIndex = index
      this.tagIndex = -1
      this.goodsList(tab.name)
    },
    // 获取秒杀商品
    getgoods (groupList_item) {
      const that = this
      return new Promise(async (resolve, reject) => {
        const _categoryFirstCode = groupList_item.categoryList.map(item => item.categoryCode)
        if (!(_categoryFirstCode.length > 0)) {
          this.grouponWeappListData = []
          return
        }
        const _data = {
          condition: {
            activityType: 7,
            categoryFirstCodes: _categoryFirstCode,
            status: 2
          },
          currPage: 1,
          pageSize: 100
        }
        await this.$http.post('/productActivity/listIncludeGroupPurchaseCount', _data).then(response => {
          if (response.data.code == 200) {
            // that.queryInfo.currPage = response.data.data.currPage
            resolve(response.data.data.data)
          } else {
            resolve([])
          }
        }).catch(err => {
          resolve([])
        })
      })
    },
    // 根据商品分类 获取秒杀商品
    async getCgoods (groupList_item, curtag, index) {
      this.tagIndex = index
      // console.log('??----ata',groupList_item,curtag,index)
      const _categoryFirstCode = index == -1 ? groupList_item.categoryList.map(item => item.categoryCode) : [curtag.categoryCode]
      if (!(_categoryFirstCode.length > 0)) {
        this.grouponWeappListData = []
        return
      }
      const _data = {
        condition: {
          activityType: 7,
          categoryFirstCodes: _categoryFirstCode,
          status: 2
        },
        currPage: 1,
        pageSize: 100
      }
      // if(curtag.level == 1){
      //   _data.condition.categoryFirstCode = curtag.categoryCode
      // }else if(curtag.level == 2){
      //   _data.condition.categorySecondCode = curtag.categoryCode
      // }
      await this.$http.post('/productActivity/listIncludeGroupPurchaseCount', _data).then(response => {
        if (response.data.code == 200) {
          this.grouponWeappListData = response.data.data.data
        } else {
          this.grouponWeappListData = []
        }
      }).catch(err => {
        this.grouponWeappListData = []
      })
    },
    // 获取拼团信息
    async getGroupInfo (activityCode) {
      if (!activityCode) { return [] }
      const _data = {
        activityCode: activityCode
      }
      // console.log('dddd...1',activityCode)
      const res = await this.$http.post('/groupRecords/queryList', _data).catch(err => {
        return []
      })
      if (res.data.code == 200) {
        return res.data.data
      } else {
        return []
      }
    },
    getLitemStyle (index) {
      this.$nextTick(() => {
        const el = this.$refs['dftItem' + index][0]
        const rows = Math.ceil(el.clientHeight / 5) + 0
        // console.log('>J?',index,el,rows)
        el.style.gridRowEnd = `span ${rows}`
        el.style.margin = `${this.compData[9]?.value / 2}px`
        // el.style = {'grid-row-end': `span ${rows}`}
        // return {'grid-row-end': 'span ' + rows}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-container{
  width: 100%;
  box-sizing: border-box;
}
.eltabs{
  margin: 0 4px;
  /deep/.el-tabs__header{
    margin-bottom: 0;
  }
}
.dft-list{
  display: flex;

  .dft-item{
    box-sizing: border-box;
    .dft-goods_img{
      position: relative;
      max-height: 500px;
      overflow: hidden;
      .countdown_area{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        box-sizing: border-box;
        height: auto;
        max-height: 40px;
        padding: 0 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(to right, #F86F30, #E91717);
        color: #fff;
        .countdown_title{
          font-weight: 700;
          font-size: 20px;
          // width: 100%;
        }
        .countdown_cnt{
          display: flex;
          // width: 90px;
          .countdown_info{
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            opacity: .8;
          }
          .countdown_time{
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            /deep/p{
              margin: 0;
            }
          }
        }
      }
      .grouponNum{
        position: absolute;
        right: 0px;
        bottom: 20px;
        background: #333;
        color: #fff;
        height: 18px;
        line-height: 16px;
        font-size: 11px;
        text-align: center;
        box-sizing: border-box;
        padding: 1px 5px;
        margin: 4px 8px;
      }
    }
    .dft-goods_description{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .dft-goods_name{
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        line-height: 20px;
        font-size: 14px;
      }
      .dft-goods_info{
        // flex: 1;
        color: #969799;
        font-size: 12px;
        line-height: 16px;
        word-break: break-all;
        margin-top: 4px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        box-sizing: border-box;
        // display: flex;
        justify-content: space-between;
        align-items: center;
        .dft-goods_info1{
          font-size: 10px;
          margin-top: 0;
        }
        .dft-goods_info2{
          font-size: 10px;
          margin-top: 0;
        }
      }
      .dft-press_area{
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        margin: 0;
        flex: 1;
        .dft-goods_price{
          flex: 1;
          height: 18px;
          color: #f44;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: flex;
          align-items: flex-end;
          position: relative;
          .price-tag{
            margin-right: 2px;
            font-size: 12px;
            line-height: 14px;
          }
          .price-sale-price{
            font-family: Avenir;
          }
          .price-origin-price{
            margin-left: 5px;
            font-size: 12px;
            line-height: 14px;
            color: #c8c9cc;
            text-decoration: line-through;
          }
          .unic_price-origin-price{
            position: absolute;
            left: 0;
            top: -15px;
          }
        }
        .dft-goods_btn{
          flex-shrink: 0;
          height: 20px;
          margin-left: 1px;
          display: flex;
          align-items: flex-end;
          .btn-icon{
            line-height: 20px;
            color: #f44;
          }
          .dft-goods_btn-class{
            height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .dft-goods_btn-class1{
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 1px solid #f44;
            font-size: 16px;
          }
          .dft-goods_btn-class3{
            padding: 0 6px;
            border-radius: 10px;
            font-size: 11px;
            background: #f44;
            color: #fff;
          }
          .dft-goods_btn-class4{
            padding: 0 6px;
            font-size: 11px;
            border: 1px solid #f44;
            color: #f44;
          }
          .dft-goods_btn-class7{
            padding: 0 6px;
            font-size: 11px;
            background: #f44;
            color: #fff;
          }
          .dft-goods_btn-class8{
            padding: 0 6px;
            font-size: 11px;
            border: 1px solid #f44;
            color: #f44;
            border-radius: 10px;
          }
        }
      }
      .dft-bargain_press_area{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        flex: 1;
        .dft-bargain_price{
          flex: 1;
          width: 100%;
          position: relative;
          .dft-bargain_price_in{
            position: absolute;
            font-size: 12px;
            color: #ff3d12;
          }
          .dft-bargain_price_start{
            top: 6px;
            left: 2px;
          }
          .dft-bargain_price_rule{
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
          }
          .dft-bargain_price_end{
            bottom: 8px;
            right: 2px;
          }
        }
        .dft-bargain_press{
          width: 100%;
          height: 32px;
          border-radius: 4px;
          flex-shrink: 0;
          display: grid;
          grid-template-columns: 1.6fr 1fr;
          text-align: left;
          overflow: hidden;
          .dft-bargain_hotv{
            background: #ffe9e5;
            color: #ff3d12;
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: center;
            height: 100%;
            padding: 0 8px;
            font-size: 14px;
            &::after{
              position: absolute;
              right: -15px;
              top: -15px;
              width: 30px;
              height: 80px;
              display: block;
              content: '';
              z-index: 3;
              background: #fc530f;
              transform: rotate(32deg);
            }
          }
          .dft-bargain_btn{
            background: #fc530f;
            color: #fff;
            font-size: 17px;
            display: flex;
            justify-content: flex-end;
            height: 100%;
            align-items: center;
            padding-right: 6px;
          }
        }
      }
    }
  }
}
.img_class{
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
//分组标题-时间
.tabs_box{
  width: 100%;
  height: 36px;
  font-size: 16px;
  line-height: 36px;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
}
.group_tab{
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  color: #6c6c6c;
  // flex-shrink: 0;
  box-sizing: border-box;
}
.activeTab{
  background: #fff;
  color: #ff3d03;
}
//分类标签
.tabin{
  margin: 4px 0;
  display: flex;
  overflow-x: auto;
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  &::-webkit-scrollbar{
    width: 0;
    height: 0;
  }
}
.ctag_item{
  display: inline-block;
  width: auto;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #333;
  background: #f2f2f4;
  border-radius: 6px;
  margin: 6px;
  padding: 0 6px;
  flex-shrink: 0;
  box-sizing: border-box;
}
.activeTag{
  background-color: red;
  color: #fff;
}
/* 渐变进度条 */
/deep/.dft-progress .el-progress-bar__inner{
  background-color: unset;
  background-image: linear-gradient(to right, #f94d07 , #fda96a);
}
.unic{
  border-radius: 4px;
  .dft-groupinfo{
    width: calc(100% - 24px);
    height: auto;
    max-height: 60px;
    padding: 8px 20px;
    margin: 4px 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    background: #fff3f0;
    .dft-groupinfo_top{
      text-align: center;
      display: flex;
      justify-content: center;
      font-size: 14px;
      .dft-groupinfo_top_s{
        color: #ff0404;
        padding: 0 4px;
      }
    }
    .dft-groupinfo_avatar{
      display: flex;
      align-items: center;
      .dft-groupinfo_avatar_item{
        margin-left: -6px;
      }
    }
  }
  .dft-groupBtn{
    width: calc(100% - 24px);
    height: 40px;
    padding: 8px 20px;
    margin: 4px 12px 12px;
    font-size: 14px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background: #fa5513;
    color: #fff;
  }
}
</style>
